import { all, fork } from "redux-saga/effects";
import catalog from "./catalog";
import metrics from "./metrics";
import dashboards from "./dashboards";
import companyConfig from "./companyConfig";

export default function* dashboardSagas() {
  yield all([fork(catalog), fork(metrics), fork(dashboards), fork(companyConfig)]);
}
